import React from "react";
import ChoiceMagneticButton from "../shared/ChoiceMagneticButton.jsx";
import ChoiceRevealOnScroll from "../shared/ChoiceRevealOnScroll.jsx";

const CustomAgentSection = ({ onOpenModal }) => (
  <section className="section-padding bg-[#050810] relative overflow-hidden pb-8" data-testid="custom-agent-section">
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(168,85,247,0.06),transparent_70%)] pointer-events-none" />

    <div className="max-w-5xl mx-auto px-6 lg:px-8 relative">
      <ChoiceRevealOnScroll>
        <div className="bento-card relative overflow-hidden border border-purple-500/25 bg-gradient-to-r from-purple-500/[0.07] via-white/[0.02] to-purple-500/[0.07] p-6 sm:p-10 lg:p-12">
          <div className="absolute -top-16 -right-16 w-48 h-48 bg-purple-500/10 rounded-full blur-3xl pointer-events-none" />

          <div className="relative flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
            <div className="flex-1 min-w-0">
              <span className="badge-mono text-purple-400 bg-purple-500/10 border border-purple-500/20 px-3 py-1.5 rounded-full inline-block mb-5 sm:mb-6">
                PATH 03 · CUSTOM VERTICAL
              </span>
              <h2 className="text-3xl sm:text-4xl md:text-[2.75rem] font-bold mb-4 sm:mb-5 leading-tight">
                Not Roofing or Real Estate?
              </h2>
              <p className="text-base sm:text-lg text-gray-400 font-body leading-relaxed max-w-xl">
                We deploy a digital employee trained on your qualification protocol — live in{" "}
                <span className="text-purple-400 font-semibold">72 hours</span>. Same playbook:{" "}
                <span className="text-purple-400 font-semibold">9-second reply</span>, qualify, log, book; your people close.
              </p>
            </div>

            <div className="flex-shrink-0 w-full lg:w-auto">
              <ChoiceMagneticButton
                className="w-full lg:w-auto bg-gradient-to-r from-purple-600 via-purple-500 to-indigo-500 px-8 py-4 rounded-2xl font-semibold text-base sm:text-lg whitespace-nowrap"
                onClick={onOpenModal}
                data-testid="custom-agent-cta"
              >
                Request a Custom Digital Employee
              </ChoiceMagneticButton>
            </div>
          </div>
        </div>
      </ChoiceRevealOnScroll>
    </div>
  </section>
);

export default CustomAgentSection;
